import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import DialogOTP from '../components/Complements/DialogOTP';
import UserPanelInfo from '../components/Complements/UserPanelInfo';
import MessageInfo from '../components/Complements/MessageInfo';
import ServiceSwitchFormReduxForm from '../components/PaymentServiceSwitch/ServiceSwitchForm'
import StandardDialog from '../components/Complements/StandardDialog';
import FormSaveAliasReferenceDialogReduxForm from "../components/Taxes/FormSaveAliasReferenceDialog"
import {
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Typography,
    Paper,
    Avatar,
    useTheme
} from '@material-ui/core';
import { validateIp } from '../functions/store';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit'
import { osName, osVersion, isMobile } from 'react-device-detect';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import ElectronicRechargesInfoPanel from "../components/Taxes/ElectronicRechargesInfoPanel"
import ElectronicRechargesFormEditFavoriteReduxForm from "../components/ElectronicRecharges/ElectronicRechargesFormEditFavorite"
import GradeIcon from '@material-ui/icons/Grade';
//import Voucher from '../components/Transfers/Voucher';
// import StandardList from "../components/Complements/StandardList"
import { feathersCreateData, feathersFindGET } from "../services"
import { createProcessMeterCode } from './../actions/metersCore'
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { changeStatusUser } from './../actions/codes'
import { getBalanceUser } from "./../actions/balances";
import { encrypt, decrypt, sendMobile } from '../functions/mobile';
import { history } from '../helpers/history';
import { urlVoucher } from '../services/urls';
//import md5 from 'md5';
import ServiceSwicthCustomAmountFormReduxForm from '../components/PaymentServiceSwitch/ServiceSwicthCustomAmountForm';
import { getAgreementsSwitchServices } from '../actions/agreementsSwitchServices'
import VoucherPaymentWeb from '../components/PaymentServiceSwitch/VoucherPaymentWeb';
import Title from '../components/Complements/Title';
import { ArrowBackIos } from '@mui/icons-material';
import { Add, Favorite } from '@material-ui/icons';

const PaymentServiceSwitchSupaContainer = props => {

    const {
        user,
        auth,
        balances,
        agreementsSwitchServices,
        otherServices,
        handleOpenSnack,
        getDeviceData,
        devices,
        updateIpDevice,
        createProcessMeterCode,
        sendEmailWithVoucher,
        type,
        identityAgreement,
        titleOptionOneMenu,
        titleOptionTwoMenu,
        allAgreementsSwicthServices,
        parameters
    } = props

    const theme = useTheme()

    const [accountSelected, setAccountSelected] = useState(balances[0])
    // eslint-disable-next-line
    const [optionsList, setOptionsList] = useState([
        { id: '1', primary: titleOptionOneMenu, secondary: '', icon: 'favorite' },
        { id: '2', primary: titleOptionTwoMenu, secondary: '', icon: 'add_circle_outline' }
    ])
    const [dataAll, setDataAll] = useState({
        referenceFavorites: [],
        rateAgreementsCore: []
    })

    const [objectSelectedAll, setObjectSelectedAll] = useState({
        agreementSelected: {
            AgreementForm: [],
            category: "",
            hasIndividualRate: 1,
            hasBilling: 1,
            name: "",
            rate: "0",
            uuid: "",
            identity: "",
            nameIdentity: ""
        },
        referenceFavoriteSelected: {},
        responseTransaction: {},
        responseConsultDebt: {
            uuidConsultDebt: "",
            customer: "",
            identification: "",
            agreement: "",
            reference: "",
            headings: []
        },
        rateAgreementsCoreSelected: {
            Secuencial: 0,
            Nombre: "",
            Comision: 0
        },
        payment: {
            concept: ""
        },
        customAmount: ""
    })

    const [listDetail, setListDetail] = useState([])

    //Dialogos

    const [dataDialogListFavorites, setDataDialogListFavorites] = useState({
        title: "",
        content: <div></div>,
        show: false
    })

    const [showDialogFormAddFavorites, setShowDialogFormAddFavorites] = useState(false)
    const [openDialogAddFavorites, setOpenDialogAddFavorites] = useState(false)
    const [isReferenceFavorites, setIsReferenceFavorites] = useState(false)

    const [OTP, setOTP] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })

    // Rederer
    const [showMenuOptions, setShowMenuOptions] = useState(true)
    const [showVoucher, setShowVoucher] = useState(false)
    const [showDetailDebt, setShowDetailDebt] = useState(false)


    //Loading
    const [loading, setLoading] = useState(false)

    const mount = () => {
        const unmount = () => {
            if (allAgreementsSwicthServices.length === 0) {
                handleGetAllAgreementsSwicthServices()
            }
            /*if(otherServices.length === 0){
                handleOpenSnack("Los servicios estan temporalmente fuera de servicio. Por favor intente mas tarde", "error")
                history.push('/')
            }*/
            updateBalances()
            handleGetReferenceFavorites()
            setObjectSelectedAll({
                ...objectSelectedAll,
                agreementSelected: {
                    AgreementForm: [],
                    category: "",
                    hasIndividualRate: 1,
                    name: "",
                    rate: "0",
                    uuid: "",
                    identity: "",
                    nameIdentity: ""
                }
            })

            setOptionsList([
                { id: '1', primary: titleOptionOneMenu, secondary: '', icon: 'favorite' },
                { id: '2', primary: titleOptionTwoMenu, secondary: '', icon: 'add' }
            ])

            setShowMenuOptions(true)
            setShowVoucher(false)
            setShowDetailDebt(false)
            //setContAttempts(0)
        }
        return unmount()
    }

    useEffect(mount, [type, identityAgreement, titleOptionOneMenu, titleOptionTwoMenu])

    // PETICIONES AL SERVIDOR

    const handleGetAllAgreementsSwicthServices = async () => {

        setLoading(true)

        try {

            await props.getAgreementsSwitchServices().then(res => {

                setLoading(false)
            }).catch(error => {
                setLoading(false)
            })


        } catch (error) {
            //console.log(error)
            setLoading(false)
        }
    }

    const updateBalances = async () => {

        setLoading(true)
        await props.getBalanceUser({ NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true })
        setLoading(false)

    }

    const handleGetReferenceFavorites = async () => {

        setLoading(true)

        try {

            let object_query = {}

            if (identityAgreement.length > 0) {
                object_query = {
                    agreement: identityAgreement,
                    state: 1
                }
            } else {
                object_query = {
                    categoryAgreement: type,
                    state: 1
                }
            }

            const data_favorite_reference = await feathersFindGET("favorite-reference", object_query)()

            //console.log(data_favorite_reference)

            setDataAll({
                rateAgreementsCore: [],
                referenceFavorites: data_favorite_reference
            })

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener los números de celular favoritos.", "error")

        }
    }

    //Default

    const handleSelectedItemMenu = (option) => {
        //console.log(option)

        try {

            const { id } = option;

            if (id === "2") {
                setShowMenuOptions(false)
                setShowVoucher(false)
            } else {

                setDataDialogListFavorites({
                    content: renderListReferenceFavorites(),
                    show: true,
                    title: "Lista de Favoritos"
                })

            }

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al seleccionar la acción.", "error")
        }
    }

    const handleChangeSelectedAgreement = (agreementSelected) => {

        try {

            setLoading(true)

            const { nameIdentity } = agreementSelected;

            const response_filter_agreement_rate = otherServices.filter((item) => item.Nombre === nameIdentity);

            //console.log(response_filter_agreement_rate)

            if (response_filter_agreement_rate.length > 0) {
                setObjectSelectedAll({
                    ...objectSelectedAll,
                    agreementSelected,
                    rateAgreementsCoreSelected: response_filter_agreement_rate[0]
                })

            } else {
                handleOpenSnack("No se ha encontrado el convenio para realizar el pago.", "info");
                setObjectSelectedAll({
                    ...objectSelectedAll,
                    agreementSelected: {
                        AgreementForm: [],
                        category: "",
                        hasIndividualRate: 1,
                        name: "",
                        rate: "0",
                        uuid: "",
                        identity: "",
                        nameIdentity: ""
                    }
                })
            }

            setLoading(false)

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al seleccionar el convenio", "error")
            setLoading(false)
        }

    }

    //Referencias Favoritas

    const renderListReferenceFavorites = () => {

        return <List>
            {
                (dataAll.referenceFavorites.length > 0) ? dataAll.referenceFavorites.map(item => {
                    return <div key={item.id}>
                        <ListItem button onClick={() => handleSelectedReferenceFavorites(item)}>
                            <ListItemAvatar>
                                <GradeIcon />
                            </ListItemAvatar>
                            <ListItemText primary={item.name} secondary={renderDetailReferenceFavorites(item)} />
                            <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="edit" onClick={() => editReferenceFavorites(item)} >
                                    <EditIcon />
                                </IconButton>
                                <IconButton edge="end" aria-label="delete" onClick={() => deleteReferenceFavorites(item)} >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    </div>
                }) : <ListItem >
                    <ListItemText primary={"No se han encontrado referencias favoritas."} />
                </ListItem>
            }
        </List>
    }

    const renderDetailReferenceFavorites = (item) => {

        return <Typography >
            <b>{`Referencia: `}</b>{`${item.reference} `}
            <br />
            <b>{`Institución: `}</b>{`${item.institution} `}
        </Typography>
    }

    const handleProcessConsultDebSelectedReferenceFavorites = async (itemFavoriteSelected) => {

        try {

            setLoading(true)

            setDataDialogListFavorites({
                ...dataDialogListFavorites,
                show: false
            })

            const { agreement, reference, additionalInformation, customamount } = itemFavoriteSelected

            const response_filter_agreement = agreementsSwitchServices.filter((ag) => ag.identity === agreement)

            //console.log(response_filter_agreement)

            if (response_filter_agreement.length > 0) {

                //console.log(dataAll)

                const response_filter_agreement_rate_core = otherServices.filter((item) => item.Nombre === response_filter_agreement[0].nameIdentity)

                if (response_filter_agreement_rate_core.length > 0) {

                    const sendData = encrypt(JSON.stringify({
                        access: "CONSULT_DEBT",
                        channel: "WEB",
                        body: {
                            agreement: response_filter_agreement[0].uuid,
                            reference,
                            addicionalData: JSON.parse(additionalInformation)
                        }
                    }))

                    const response_consult_debt = await feathersCreateData("switch-services", {
                        sendData
                    })()

                    //console.log(response_consult_debt)

                    const { responseData } = response_consult_debt

                    const response_consult_debt_decrypt = JSON.parse(decrypt(responseData))

                    const { error, response } = response_consult_debt_decrypt

                    if (error === false) {

                        const { headings } = response

                        if (headings.length > 0) {

                            setIsReferenceFavorites(true)

                            setShowDetailDebt(true)
                            setShowMenuOptions(false)

                            if (customamount) {
                                response.headings[0].amount = customamount;
                                response.headings[0].valueWithCommission = parseFloat(parseFloat(customamount) + parseFloat(response.headings[0].rate)).toFixed(2);
                            }

                            setObjectSelectedAll({
                                ...objectSelectedAll,
                                responseConsultDebt: response,
                                agreementSelected: {
                                    AgreementForm: response_filter_agreement[0].AgreementForm,
                                    category: response_filter_agreement[0].category,
                                    hasIndividualRate: response_filter_agreement[0].hasIndividualRate,
                                    identity: response_filter_agreement[0].identity,
                                    name: response_filter_agreement[0].name,
                                    nameIdentity: response_filter_agreement[0].nameIdentity,
                                    rate: response_filter_agreement[0].rate,
                                    uuid: response_filter_agreement[0].uuid
                                },
                                rateAgreementsCoreSelected: {
                                    Comision: response_filter_agreement_rate_core[0].Comision,
                                    Nombre: response_filter_agreement_rate_core[0].Nombre,
                                    Secuencial: response_filter_agreement_rate_core[0].Secuencial
                                }
                            })

                            handleProccessViewDetailConsultDebt(response)

                        } else {
                            handleOpenSnack("No se han encontrado deudas.", "info")
                        }

                    } else {
                        handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
                    }
                    setLoading(false)

                } else {

                    setLoading(false)
                    handleOpenSnack("No se ha encontrado el convenio registrado.", "info")
                }

            } else {

                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio registrado.", "info")
            }

        } catch (error) {

            setLoading(false)
            handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
        }
    }

    const handleCancelCustomAmountForm = () => {

        setDataDialogListFavorites({
            ...dataDialogListFavorites,
            content: renderListReferenceFavorites(),
            title: "Lista de Favoritos"
        })
    }

    const handleSubmitCustomAmountForm = (dataCustomAmountForm) => {
        //console.log(dataCustomAmountForm)

        try {

            const { institution, customamount, reference } = dataCustomAmountForm

            const response_filter_agreement_custom_amount = agreementsSwitchServices.filter((ag) => ag.name === institution)
            //console.log(response_filter_agreement_custom_amount)
            if (response_filter_agreement_custom_amount.length > 0) {
                setDataDialogListFavorites({
                    ...dataDialogListFavorites,
                    show: false
                })
                handleProcessConsultDebSelectedReferenceFavorites({
                    agreement: response_filter_agreement_custom_amount[0].identity,
                    reference,
                    customamount
                })
            } else {
                handleOpenSnack("No se ha encontrado el convenio.", "info")
            }
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al consultar el convenio.", "info")
        }
    }

    const handleSelectedReferenceFavorites = (itemFavoriteSelected) => {

        try {

            const { agreement, institution, reference } = itemFavoriteSelected

            if (agreement === "b47120e6-b782-4f33-ba05-b0dd2df5675d") {
                //console.log("ENTRO")
                setDataDialogListFavorites({
                    ...dataDialogListFavorites,
                    content: <ServiceSwicthCustomAmountFormReduxForm
                        initialValues={{ reference, institution }}
                        titleLabelReference={"Número de tarjeta"}
                        onCancelAction={handleCancelCustomAmountForm}
                        onSubmit={handleSubmitCustomAmountForm}
                    />,
                    title: "Monto a Pagar",
                    show: true
                })

            } else {
                handleProcessConsultDebSelectedReferenceFavorites(itemFavoriteSelected)
            }

        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("No se han encontrado valores para pago. Por favor vuelva a intentar mas tarde.", "info")
        }
    }

    const deleteReferenceFavorites = async (row) => {

        try {

            setLoading(true)

            const sendData = encrypt(JSON.stringify({
                action: "UPDATE",
                dataFavoriteReference: {
                    id: row.id,
                    state: 0
                }
            }))

            await feathersCreateData("procces-favorite-reference", { sendData })()

            const { referenceFavorites } = dataAll

            let auxReferenceFavorites = referenceFavorites

            let index = referenceFavorites.findIndex((item) => item.id === row.id)

            auxReferenceFavorites.splice(index, 1)

            setDataAll({
                ...dataAll,
                referenceFavorites: auxReferenceFavorites
            })

            setDataDialogListFavorites({
                ...dataDialogListFavorites,
                content: renderListReferenceFavorites()
            })

            handleOpenSnack("Se ha eliminado correctamente.", "success")

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al eliminar un favorito.", "error")

        }
    }

    //Editar Referencia Favorita

    const editReferenceFavorites = (item) => {
        //console.log(item)

        try {

            setObjectSelectedAll({
                ...objectSelectedAll,
                referenceFavoriteSelected: item
            })

            localStorage.setItem("referenceFavorites", JSON.stringify(item))

            setLoading(true)

            const response_filter_agreement = agreementsSwitchServices.filter((agree) => agree.identity === item.agreement)

            //console.log(response_filter_agreement)

            if (response_filter_agreement.length > 0) {

                let titleLabel = (response_filter_agreement[0].AgreementForm.length > 0) ? response_filter_agreement[0].AgreementForm[0].label : "Referencia"

                localStorage.setItem("agreementSelectedEditFavorites", JSON.stringify(response_filter_agreement[0]))

                setDataDialogListFavorites({
                    show: true,
                    content: renderFormEditFavorites(response_filter_agreement[0], item.name, item.reference, titleLabel),
                    title: "Editar Favoritos"
                })

                setLoading(false)

            } else {
                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio.", "info")
            }

        } catch (error) {
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener información de la referencia favorita.", "error")
        }
    }

    const handleUpdatedFavorites = async (valuesFormEditReferenceFavorites) => {

        setLoading(true)

        try {

            let flag_validation_repeat_favorite = false

            const { alias, reference } = valuesFormEditReferenceFavorites

            const agreement = JSON.parse(localStorage.getItem("agreementSelectedEditFavorites"))

            const referenceFavorites = JSON.parse(localStorage.getItem("referenceFavorites"))

            const response_filter_agreement = agreementsSwitchServices.filter((row) => row.name === agreement.name)

            const response_filter_data_reference_favorite = dataAll.referenceFavorites.filter((item) => item.id === referenceFavorites.id)

            if (response_filter_agreement.length > 0) {

                if (alias.toUpperCase() !== response_filter_data_reference_favorite[0].name) {

                    const response_filter_favorite_by_alias = dataAll.referenceFavorites.filter((row) => row.name === alias.toUpperCase())

                    if (response_filter_favorite_by_alias.length > 0) {
                        flag_validation_repeat_favorite = true
                    } else {
                        flag_validation_repeat_favorite = false
                    }

                } else {
                    flag_validation_repeat_favorite = false
                }

                if (flag_validation_repeat_favorite === false) {

                    if (reference !== response_filter_data_reference_favorite[0].reference) {

                        const response_filter_favorite_by_reference = dataAll.referenceFavorites.filter((row) => row.reference === reference)

                        if (response_filter_favorite_by_reference.length > 0) {
                            flag_validation_repeat_favorite = true
                        } else {
                            flag_validation_repeat_favorite = false
                        }
                    } else {
                        flag_validation_repeat_favorite = false
                    }

                    if (flag_validation_repeat_favorite === false) {
                        const sendData = encrypt(JSON.stringify({
                            action: "UPDATE",
                            dataFavoriteReference: {
                                id: referenceFavorites.id,
                                name: alias.toUpperCase(),
                                reference,
                                agreement: response_filter_agreement[0].identity,
                                institution: agreement.name,
                                additionalInformation: JSON.stringify({ numberOfQuotas: 1, paymentType: 23 })
                            }
                        }))
                        await feathersCreateData("procces-favorite-reference", { sendData })()
                        handleGetReferenceFavorites()
                        setDataDialogListFavorites({
                            ...dataDialogListFavorites,
                            show: false
                        })
                        handleOpenSnack("Se ha actualizado correctamente.", "success")
                        setLoading(false)
                    } else {
                        setLoading(false)
                        handleOpenSnack("La referencia ya existen.", "info")
                    }
                } else {
                    setLoading(false)
                    handleOpenSnack("El alias ya existen.", "info")
                }

            } else {
                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio seleccionado.", "info")
            }

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al actualizar la referencia favorita.", "error")
            setLoading(false)

        }
    }

    const handleChangeAgreementEditFavorite = (agreementSelectedEditReferenceFavorites) => {

        try {
            localStorage.setItem("agreementSelectedEditFavorites", JSON.stringify(agreementSelectedEditReferenceFavorites))
        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al seleccionar el convenio.", "error")
        }
    }

    const handleCancelFormEditFavorites = () => {
        try {

            setDataDialogListFavorites({
                show: false,
                content: renderListReferenceFavorites(),
                title: "Lista de Favoritos"
            })

        } catch (error) {
            handleOpenSnack("Ha ocurrido un error. Por favor vuelva a intentar.", "error")
        }
    }

    const renderFormEditFavorites = (agreement, alias, reference, labelReference) => {
        return <div><ElectronicRechargesFormEditFavoriteReduxForm
            onSubmit={handleUpdatedFavorites}
            agreements={agreementsSwitchServices}
            handleChangeAgreementEditFavorite={handleChangeAgreementEditFavorite}
            onCancelAction={handleCancelFormEditFavorites}
            initialValues={{
                agreement,
                alias,
                reference
            }}
            titleLabelReference={labelReference}
            titleLabelAgreement={"Seleccione un Convenio"}
        /></div>
    }

    //Dialogos

    const handleCloseDialogListFavorites = () => {
        setDataDialogListFavorites({
            ...dataDialogListFavorites,
            show: false
        })
    }

    // Agregar a favoritos

    const handleCloseDialogAddFavorites = () => {
        setOpenDialogAddFavorites(false)
        setShowDialogFormAddFavorites(false)
    }

    const handleSubmitAddFavorites = async (values) => {
        //console.log(values)

        try {

            setLoading(true);

            const { alias } = values

            const response_filter_reference_favorites = dataAll.referenceFavorites.filter((row) => row.name === alias.toUpperCase())

            if (response_filter_reference_favorites.length > 0) {
                handleOpenSnack("El alias ya existe.", "info")
            } else {

                const sendData = encrypt(JSON.stringify({
                    action: "CREATE",
                    dataFavoriteReference: {
                        reference: objectSelectedAll.responseConsultDebt.reference,
                        name: alias.toUpperCase(),
                        agreement: objectSelectedAll.agreementSelected.identity,
                        institution: objectSelectedAll.agreementSelected.name,
                        additionalInformation: JSON.stringify({ numberOfQuotas: 1, paymentType: 23 }),
                        categoryAgreement: type,
                        state: 1,
                        user: auth.id
                    }
                }))

                await feathersCreateData("procces-favorite-reference", {
                    sendData
                })()

                /* let auxDataFavoritesReference = dataAll.referenceFavorites

                auxDataFavoritesReference.push({
                    reference: objectSelectedAll.responseConsultDebt.reference,
                    name: alias.toUpperCase(),
                    agreement: objectSelectedAll.agreementSelected.identity,
                    institution: objectSelectedAll.agreementSelected.name,
                    additionalInformation: JSON.stringify({ numberOfQuotas: 1, paymentType: 23 }),
                    categoryAgreement: type,
                    state: 1,
                    user: auth.id
                })

                setDataAll({
                    ...dataAll,
                    referenceFavorites: auxDataFavoritesReference
                }) */
                handleGetReferenceFavorites()
                setOpenDialogAddFavorites(false)
                setShowDialogFormAddFavorites(false)
                setIsReferenceFavorites(true)


                handleOpenSnack('Se ha almacenado exitosamente a favoritos.', 'success')

            }

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack('No se ha podido registrar a favoritos. Por favor intente nuevamente.', 'error')

        }
    }

    const handleSaveFavorites = () => {
        setOpenDialogAddFavorites(true)
        setShowDialogFormAddFavorites(true)
    }

    //OTP

    const handleUpdatedBalances = async () => {
        await props.getBalanceUser({ NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true }).then(res => {

            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.PRODUCTBANKID === accountSelected.PRODUCTBANKID) ? true : false;

            })

            setAccountSelected(getdataaccountselected[0])

        })
            .catch(err => {
                //console.log(' error al obtener balances ', err)
            })
    }

    const handleOTPCompare = async ({ data }) => {

        try {

            setLoading(true)
            setOTP({
                ...OTP,
                openOtp: false
            })

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type: 29,
                inputOtp: data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type: typeMessage, viewDialogOtp } = responseValidateCode;

            if (error === false) {

                const array_headings = []

                array_headings.push(objectSelectedAll.responseConsultDebt.headings[0])

                //console.log(objectSelectedAll)

                const sendData = encrypt(JSON.stringify({
                    access: "PAYMENT",
                    channel: "WEB",
                    body: {
                        agreement: objectSelectedAll.agreementSelected.uuid,
                        SecuencialOtherServices: objectSelectedAll.rateAgreementsCoreSelected.Secuencial,
                        SecuencialCuenta: accountSelected.Secuencial,
                        NumeroCuentaOrigen: accountSelected.PRODUCTBANKID,
                        concept: objectSelectedAll.payment.concept,
                        billingData: {
                            identification: user.Identificacion,
                            name: auth.customer.first_name + " " + auth.customer.second_name + " " + auth.customer.surname + " " + auth.customer.second_surname,
                            cellphone: (auth.cellphone !== null) ? auth.cellphone : "9999999999",
                            email: (auth.email !== "") ? auth.email : "na@gmail.com",
                            address: "Sin dirección"
                        },
                        otp: data,
                        NumeroCliente: user.NumeroCliente,
                        headings: array_headings,
                        uuidConsultDebt: objectSelectedAll.responseConsultDebt.uuidConsultDebt,
                        IdentificacionDeudor: objectSelectedAll.responseConsultDebt.identification,
                        NombreDeudor: objectSelectedAll.responseConsultDebt.customer,
                        reference: objectSelectedAll.responseConsultDebt.reference
                    },
                    device: {
                        ip,
                        mac,
                        device
                    }
                }))

                const response_payment = await feathersCreateData("switch-services", {
                    sendData
                })()

                //console.log(response_payment)

                const { responseData } = response_payment

                const response_payment_decrypt = JSON.parse(decrypt(responseData))

                const { error, response, errors } = response_payment_decrypt;

                if (error === false) {

                    setOTP({
                        ...OTP,
                        openOtp: false
                    })
                    handleUpdatedBalances()
                    setObjectSelectedAll({
                        ...objectSelectedAll,
                        responseTransaction: response
                    })
                    setShowVoucher(true)
                    handleOpenSnack('Se ha realizado exitosamente el pago.', 'success')

                } else {

                    setOTP({
                        ...OTP,
                        openOtp: false
                    })
                    handleOpenSnack((errors.length > 0) ? errors[0].message : "Ha ocurrido un error al realizar el pago.", "error")
                }

                setLoading(false)

            } else {

                if (viewDialogOtp === false) {
                    setOTP({ ...OTP, openOtp: false })
                } else {
                    setOTP({
                        ...OTP,
                        openOtp: true
                    })
                }
                setLoading(false)
                handleOpenSnack(message, typeMessage);

            }

        } catch (error) {

            setLoading(false)
            setOTP({
                ...OTP,
                openOtp: false
            })
            handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")

        }
    }

    const handleGenerateOtp = async (type) => {

        setLoading(true)

        try {

            const { ip } = devices

            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)

            let deviceData = `${osName} ${osVersion}`
            let mac = 'NAVEGADOR'

            if (!isEmpty(devices)) {
                const { device, ip: ipDevice, mac: macDevice } = devices
                deviceData = device;
                ipSend = ipDevice;
                mac = macDevice;
            }

            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type, deviceData, ip: ipSend, mac
            }))

            createProcessMeterCode({ sendData })
                .then(({ payload }) => {
                    //const { result, data } = payload
                    setOTP({
                        ...OTP,
                        //id: data.sequence,
                        //code: result,
                        type,
                        openOtp: true
                    })
                    setLoading(false)
                }).catch(err => {
                    //console.log(err)
                    setLoading(false)
                    handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')
                })

        } catch (error) {

            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    const handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 6
        if (valueinput.target.value.toString().length === tokenLength) {
            handleOTPCompare({ data: valueinput.target.value.toString() });
        }
    }

    //Consulta de Deuda

    const handleValidatePatternReference = (AgreementForm, valueReference) => {

        if (AgreementForm.length > 0) {

            let statusValidation = true

            let validatePattern = new RegExp(AgreementForm[0].pattern);

            if (validatePattern.test(valueReference) === false) {
                statusValidation = false
                handleOpenSnack(AgreementForm[0].messageValidationPattern, "error")
            } else {
                if (valueReference.length > parseInt(AgreementForm[0].maxLength)) {
                    statusValidation = false
                    handleOpenSnack(`Debe tener ${AgreementForm[0].maxLength} carácteres o menos.`, "error")
                } else {
                    statusValidation = true
                }
            }

            //console.log(statusValidation)

            return statusValidation

        } else {
            return true
        }
    }

    const handleSubmitConsultDebt = async (valueFormConsultDebt) => {
        //console.log(valueFormConsultDebt)

        try {

            setLoading(true)

            const { reference, customamount } = valueFormConsultDebt

            if (objectSelectedAll.agreementSelected.uuid.length > 0) {

                //Validar por el pattern

                if (handleValidatePatternReference(objectSelectedAll.agreementSelected.AgreementForm, reference) === true) {

                    const response_filter_reference = dataAll.referenceFavorites.filter((item) => item.reference === reference)

                    if (response_filter_reference.length > 0) {
                        setIsReferenceFavorites(true)
                    } else {
                        setIsReferenceFavorites(false)
                    }

                    const sendData = encrypt(JSON.stringify({
                        access: "CONSULT_DEBT",
                        channel: "WEB",
                        body: {
                            agreement: objectSelectedAll.agreementSelected.uuid,
                            reference,
                            addicionalData: {
                                numberOfQuotas: 1,
                                paymentType: 23
                            }
                        }
                    }))

                    const response_consult_debt = await feathersCreateData("switch-services", {
                        sendData
                    })()

                    const { responseData } = response_consult_debt

                    const response_consult_debt_decrypt = JSON.parse(decrypt(responseData))

                    const { error, response } = response_consult_debt_decrypt

                    if (error === false) {

                        const { headings } = response

                        if (headings.length > 0) {

                            if (customamount) {
                                response.headings[0].amount = customamount;
                                response.headings[0].valueWithCommission = parseFloat(parseFloat(customamount) + parseFloat(response.headings[0].rate)).toFixed(2);
                            }

                            setObjectSelectedAll({
                                ...objectSelectedAll,
                                responseConsultDebt: response
                            })

                            handleProccessViewDetailConsultDebt(response)

                        } else {
                            handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
                        }

                    } else {
                        handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
                    }
                    setLoading(false)

                }

            } else {
                handleOpenSnack("Debe seleccionar un convenio.", "info")
            }

            setLoading(false)
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("No se han generado valores a pagar. Por favor intente mas tarde.", "info")
        }
    }

    const handleCancelActionConsultDebt = () => {
        setShowMenuOptions(true)
        setShowVoucher(false)
    }

    const handleProccessViewDetailConsultDebt = (dataResponse) => {

        try {

            setListDetail([
                {
                    id: '1',
                    title: dataResponse.customer,
                    data: dataResponse.identification,
                    icon: 'person',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '2',
                    title: (objectSelectedAll.agreementSelected.AgreementForm.length > 0) ? objectSelectedAll.agreementSelected.AgreementForm[0].label : "Referencia",
                    data: dataResponse.reference,
                    icon: 'badge',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '3',
                    title: "Rubro",
                    data: dataResponse.headings[0].description,
                    icon: 'info',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '4',
                    title: "Intitución",
                    data: dataResponse.agreement,
                    icon: 'business',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '5',
                    title: "Valor",
                    data: dataResponse.headings[0].amount,
                    icon: 'attach_money',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '6',
                    title: "Comisión",
                    data: dataResponse.headings[0].rate,
                    icon: 'attach_money',
                    pstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontWeight: 'bold',
                        fontSize: '0.875rem'
                    },
                    sstyle: {
                        // color: 'rgb(0, 0, 1)',
                        fontSize: '0.8rem'
                    }
                },
                {
                    id: '7',
                    title: 'Valor a pagar',
                    data: dataResponse.headings[0].valueWithCommission,
                    icon: 'monetization_on',
                    pstyle: {
                        color: '#b98919',
                        fontWeight: 'bold',
                        fontSize: '1.05rem'
                    },
                    sstyle: {
                        color: '#b98919',
                        fontWeight: 'bold',
                        fontSize: '1rem'
                    }
                },
            ])

            setShowDetailDebt(true)

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al mostrar el detalle de la deuda", "error")
        }
    }

    //Pago

    const handleSubmitPayment = (valueFormConsultDebt) => {

        try {

            setLoading(true)

            const { description = 'Pago de servicios' } = valueFormConsultDebt

            console.log("valueFormConsultDebt", valueFormConsultDebt)

            setObjectSelectedAll({
                ...objectSelectedAll,
                payment: {
                    concept: description.toUpperCase()
                }
            })

            //console.log(accountSelected.SaldoTransaccional)

            if (parseFloat(objectSelectedAll.responseConsultDebt.headings[0].valueWithCommission) > parseFloat(accountSelected.SALDOINT)) {

                setLoading(false)
                handleOpenSnack('El valor excede el saldo disponible.', 'error')

            } else {

                handleGenerateOtp(29)

            }

        } catch (error) {

            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    const handleBackDetailDebt = () => {
        setShowDetailDebt(false)
        setShowMenuOptions(false)
        setShowVoucher(false)
    }

    //VOUCHER

    const handleSendEmailWithVoucher = () => {

        setLoading(true)

        const { CorreoElectronico } = user;

        const { DocumentoTransaccion } = objectSelectedAll.responseTransaction;

        let object_send_email_with_voucher = {
            Documento: "voucher_" + DocumentoTransaccion,
            Email: CorreoElectronico
        }

        sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {

                const { message, type } = response.payload;

                setLoading(false)

                handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                setLoading(false)
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }

    const handleCancelTransferForm = () => {
        history.push('/')
    }

    const handleDownloadVoucher = () => {
        window.open(urlVoucher + objectSelectedAll.responseTransaction.nombreArchivoComprobante + ".pdf", '_blank');
    }

    const handleSetNewPayment = () => {
        setShowVoucher(false)
        setShowMenuOptions(true)
        setShowDetailDebt(false)
        setObjectSelectedAll({
            ...objectSelectedAll,
            responseTransaction: {}
        })
    }

    //Renderizar Vistas

    const renderProcess = () => {
        return (showDetailDebt === false) ? <ServiceSwitchFormReduxForm
            onSubmit={handleSubmitConsultDebt}
            agreementsSelected={objectSelectedAll.agreementSelected}
            setAgreementsSelected={handleChangeSelectedAgreement}
            agreements={agreementsSwitchServices}
            onCancelAction={handleCancelActionConsultDebt}
            titleSelectAgreement={"Seleccione un convenio"}
            titleLabelReference={(objectSelectedAll.agreementSelected.AgreementForm.length > 0) ? objectSelectedAll.agreementSelected.AgreementForm[0].label : "Referencia"}
        /> : renderDetailConsultDebt()
    }

    const renderDetailConsultDebt = () => {
        return <ElectronicRechargesInfoPanel
            listDetail={listDetail}
            processPayment={handleSubmitPayment}
            getBack={handleBackDetailDebt}
            isFavorites={isReferenceFavorites}
            saveFavorites={handleSaveFavorites}
        />
    }

    const renderVoucher = () => {
        return <VoucherPaymentWeb
            amount={parseFloat(objectSelectedAll.responseTransaction.MontoPagar).toFixed(2)}
            titleheader={"Valor Cancelado"}
            titlebuttonnew={"Nuevo Pago"}
            titleone={"DATOS SERVICIO"}
            titletwo={"DATOS EMISOR"}
            databodyone={[
                {
                    title: "Servicio",
                    value: objectSelectedAll.responseTransaction.Servicio,
                    order: 1
                },
                {
                    title: "Convenio",
                    value: objectSelectedAll.responseTransaction.NombreInstitucion,
                    order: 2
                },
                {
                    title: "Referencia",
                    value: objectSelectedAll.responseTransaction.NumeroDeReferencia,
                    order: 3
                },
                {
                    title: "Identificación",
                    value: objectSelectedAll.responseTransaction.IdentificacionDeudor,
                    order: 4
                },
                {
                    title: "Deudor",
                    value: objectSelectedAll.responseTransaction.NombreDeudor,
                    order: 5
                },
                {
                    title: "Rubro",
                    value: objectSelectedAll.responseTransaction.Rubros,
                    order: 6
                },
                {
                    title: "Factura",
                    value: objectSelectedAll.responseTransaction.Factura,
                    order: 7
                }
            ]}
            databodytwo={
                [
                    {
                        title: "# Socio",
                        value: user.NumeroCliente,
                        order: 8
                    },
                    {
                        title: "Socio",
                        value: user.Apellidos + " " + user.Nombres,
                        order: 9
                    },
                    {
                        title: "Número de Cuenta",
                        value: objectSelectedAll.responseTransaction.NroDeCuenta,
                        order: 10
                    },
                    {
                        title: "Fecha",
                        value: objectSelectedAll.responseTransaction.FechaPago,
                        order: 11
                    },
                    {
                        title: "Concepto",
                        value: objectSelectedAll.responseTransaction.Concepto,
                        order: 12
                    },
                    {
                        title: "Dcto. de transacción",
                        value: "# " + objectSelectedAll.responseTransaction.DocumentoTransaccion,
                        order: 13
                    },
                    {
                        title: "Dispositivo",
                        value: objectSelectedAll.responseTransaction.dispositivo,
                        order: 14
                    }
                ]
            }
            typesizegrid={6}
            handleSendEmailWithVoucher={handleSendEmailWithVoucher}
            handleCancelTransferForm={handleCancelTransferForm}
            onActionAfter={handleSetNewPayment}
            handleDownloadVoucher={handleDownloadVoucher}
            handleDownloadDevice={() => {
                try {
                    let send = {
                        type: 'action',
                        action: 'export_voucher',
                        data: urlVoucher + objectSelectedAll.responseTransaction.nombreArchivoComprobante + ".pdf",
                        nameFile: objectSelectedAll.responseTransaction.nombreArchivoComprobante,
                        extension: 'pdf',
                        messageSend: 'PAGO DE ' + type
                    }
                    sendMobile(JSON.stringify(send))
                } catch (error) {
                    //console.log(error)
                }
            }}
        />
    }

    const renderMenu = () => {

        return <List style={{
            flexGrow: 1,
            padding: "20px",
            // border: '2px solid #BEBCC0',
            backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
            borderRadius: "16px"
        }}>

            <ListItem button
                onClick={() => {
                    handleSelectedItemMenu({ id: "1" })
                }
                }
            >
                <ListItemAvatar>
                    <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                        <Favorite />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Seleccione referencia favorita"} secondary="" />
            </ListItem>
            <ListItem button
                onClick={() => {
                    handleSelectedItemMenu({ id: "2" })
                }}
            >
                <ListItemAvatar>
                    <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                        <Add />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={"Agregar Nueva Referencia"} secondary="" />
            </ListItem>
        </List>
    }

    const renderBody = () => {

        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <UserPanelInfoMobile
                    user={user}
                    balances={balances}
                    accountSelected={accountSelected}
                    changeAccount={setAccountSelected}
                >
                    {(showMenuOptions === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}

                </UserPanelInfoMobile>
            }

        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return <Paper elevation={0}
                    style={{
                        padding: "20px",
                        // border: '2px solid #BEBCC0',

                        borderRadius: "16px",
                    }}
                >
                    <Grid container spacing={3}>
                        <Grid xs={12}>
                            <Title><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Pago de Servicios</Title>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <UserPanelInfo
                                user={user}
                                balances={balances}
                                accountSelected={accountSelected}
                                changeAccount={setAccountSelected}
                                tittle={"CONSEJO DE LA JUDICATURA"}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            {(showMenuOptions === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}
                        </Grid>
                    </Grid>

                </Paper>

            }
        }
    }
    //import { filterArrayEqual } from '../functions/arrays';
    const timeLifeTokenObj = filterArrayEqual(props.parameters, 'code', 'TIME_LIFE_TOKEN')
    const timeLifeToken = parseInt(timeLifeTokenObj[0].value)

    return (


        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <StandardDialog
                open={dataDialogListFavorites.show}
                title={dataDialogListFavorites.title}
                handleClose={handleCloseDialogListFavorites}
                children={dataDialogListFavorites.content}
            />
            {
                (openDialogAddFavorites === true) && <FormSaveAliasReferenceDialogReduxForm
                    isOpenDialog={showDialogFormAddFavorites}
                    onCloseDialog={handleCloseDialogAddFavorites}
                    titleDialog={"Añadir a favoritos."}
                    onSubmit={handleSubmitAddFavorites}
                    labelField={"Nombre de la referencia"}
                    placeholderField={"Ejemplo: Iphone 7"}
                    nameButtonActionSave={"Guardar"}
                    nameButtonActionCancel={"Cancelar"}
                />
            }
            <DialogOTP
                openDialogOTP={OTP.openOtp}
                onCloseDialogOTP={() => setOTP({ ...OTP, openOtp: false })}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
            />
            <LoadingScreen open={loading} />
        </div>
    )
}

export default connect(null, {
    createProcessMeterCode,
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser,
    getAgreementsSwitchServices
})(PaymentServiceSwitchSupaContainer)
